module.exports = function getResource(label, vars = []) {
    let resources = {
        goToBasket: 'Go To Basket',
        item: 'item',
        items: 'items'
    };
    return resources[label];
};
